import './parts/schedule-locations';
import './parts/schedule-items';
import './work-order-schedule-location-index';
import { html, LitEntity, SirenActionMixin } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import { StoreMixin } from '../utility/store-mixin';

class WorkOrderScheduleIndex extends StoreMixin(IndexMixin(SirenActionMixin(LitEntity))) {
  static get properties() {
    return {
      locationHref: { type: String, attribute: false },
    };
  }

  getViews() {
    return [
      {
        default: true,
        name: 'locations',
        render: () => html`
          <work-order-schedule-location-index
            .path="${this.tail}"
            .href="${this.href}"
          ></work-order-schedule-location-index>
        `,
      },
      {
        name: 'work-orders',
        render: () => html`<schedule-items .href="${this.locationHref}"></schedule-items>`,
      },
    ];
  }

  _stateChanged({ query }) {
    this.locationHref = (query || {}).locationId;
  }
}

customElements.define('work-order-schedule-index', WorkOrderScheduleIndex);
